import { render, staticRenderFns } from "./compareCar.vue?vue&type=template&id=2d4e91eb&"
import script from "./compareCar.vue?vue&type=script&lang=ts&"
export * from "./compareCar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports